import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  HttpHeadersPayload,
  HttpRequestMethods,
  ReplaceItem,
  handleError
} from '@com-delta-idp/mnx-utils';
import { Observable } from 'rxjs';
import { EndpointKey, IDP_APP, MFA_OAUTH_URL } from '../../../constants';
import { OauthAEMConfig } from '../../../models';
import { CancelAuthentication } from '../../../models/multi-factor-authentication.interfaces';
import { UtilService } from '../../util-service/util-service';

@Injectable({
  providedIn: 'root'
})
export class CancelAuthenticationService {
  cancelAuthenticationHeader: HttpHeadersPayload = {
    'Content-Type': 'application/vnd.pingidentity.cancelAuthentication+json',
    'X-XSRF-Header': 'PingFederate',
    rejectUnauthorized: 'false'
  };

  _errorHandler = handleError.bind(this);

  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private utils: UtilService
  ) {}

  cancelAuthentication = (
    authConfig: OauthAEMConfig,
    flowIdValue: string
  ): Observable<CancelAuthentication> => {
    const getCancelAuthenticationUrl = this.utils.getPingServiceUrl(
      authConfig,
      flowIdValue
    ).loginAuthWithCredentialsUrl;

    const cancelAuthenticationUrl: ReplaceItem[] = [
      {
        src: MFA_OAUTH_URL,
        target: getCancelAuthenticationUrl
      }
    ];

    return new ApiBuilder<undefined, CancelAuthentication>(
      this.http,
      this.appConfig
    )
      .app(IDP_APP.COMMON)
      .endpointKey(EndpointKey.MFA_OAUTH_URL)
      .overrideEndpoint(cancelAuthenticationUrl)
      .method(HttpRequestMethods['POST'])
      .timeOut(authConfig.MFA_TIMEOUT ?? 10000)
      .httpHeaders(this.cancelAuthenticationHeader)
      .errorHandler(this._errorHandler)
      .library('CANCEL_AUTHENTICATION_SERVICE')
      .withCredentials(true)
      .create();
  };
}
